import React, { useCallback } from "react";
import { func } from "prop-types";
import { sxClassName, sxProps } from "../props/sx";
import { spacingClassName, spacingProps } from "../props/spacing";
import Link from "../Link";
import Inline from "../Inline";
import { classes } from "../utils/classes";
import { useDropDown } from "../utils/DropDownProvider/context";
import { useHeader } from "../Header/context";

const DropdownMenuItemLink = ({ className = "", children, onClick = () => {}, ...props }) => {
	const { onClose } = useHeader();
	const { changeCurrentAction, initialAction, currentAction } = useDropDown();
	const handleClick = useCallback(
		e => {
			changeCurrentAction(null);
			onClose();
			onClick(e);
			setTimeout(() => {
				changeCurrentAction(initialAction);
			}, 100);
		},
		[changeCurrentAction, initialAction, currentAction],
	);
	return (
		<Link
			isBaseClassName={false}
			className={classes("dropdown-menu-item-link", className)}
			onClick={handleClick}
			{...props}
		>
			{children}
		</Link>
	);
};

DropdownMenuItemLink.propTypes = {
	...Link.propTypes,
	onClick: func,
};

const DropdownMenuItem = ({
	className = "",
	children,
	sx = { ...sxProps },
	spacing = { ...spacingProps },
}) => (
	<li
		className={classes(
			"dropdown-menu-item",
			...sxClassName(sx),
			...spacingClassName(spacing),
			className,
		)}
	>
		{children}
	</li>
);

DropdownMenuItem.propTypes = {
	...Inline.propTypes,
};

DropdownMenuItem.Link = DropdownMenuItemLink;

export default DropdownMenuItem;
